module.exports = __webpack_public_path__ + "img/2024-03-19a_3.d4006b59.jpg";